import UserRepository from "../repository/user-repository";

class UserService
{
    #userRepository;

    constructor() {
        this.#userRepository = new UserRepository();
    }

    async gridview(query) {
        try {
            const data = await this.#userRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findOne(id) {
        try {
            const data = await this.#userRepository.getOneById(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async create(user) {
        try {
            const data = await this.#userRepository.create(user);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async edit(user) {
        try {
            const data = await this.#userRepository.edit(user);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async changePassword(id) {
        try {
            const data = await this.#userRepository.resetPassword(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default UserService;